import React, { Component } from 'react';
import {withRouter} from "react-router-dom";

import { validateAccount } from "../../services";
import AnonymousFormLayout from "../../layout/anonymous-form-layout";
import AccountValidateConfirmation from "./account-validate-confirmation";
import AccountValidateFailure from "./account-validate-failure";
import Spinner from "react-bootstrap/Spinner";

class AccountActivate extends Component {
  state = {
    loaded: false,
    successful: undefined
  };

  componentDidMount() {
    const { validateId } = this.props.match.params;

    const onSuccess = (response, body) => {
      if (response.status === 202) {
        this.setState({
          ...this.state,
          loaded: true,
          successful: true
        });
      } else if (response.status === 412) {
        this.setState({
          ...this.state,
          loaded: true,
          successful: false
        });
      }
    };

    const requestData = {
      validationId: validateId
    };
    validateAccount(requestData, onSuccess);
  }

  render() {
    return (
      <AnonymousFormLayout backgroundImageStyle="bg-validate-image">
        {
          !this.state.loaded &&
          <div className="p-5 form-container" id="view-validate-local-account-waiting">
            <Spinner animation="border"/>
          </div>
        }
        {
          this.state.loaded && this.state.successful && <AccountValidateConfirmation/>
        }
        {
          this.state.loaded && !this.state.successful && <AccountValidateFailure/>
        }
      </AnonymousFormLayout>
    );
  }
}

export default withRouter(AccountActivate)